<template lang="pug">
  #app
    router-view
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapGetters(['getCurrentSceneName']),
  },
  mounted() {
    document.title = this.getCurrentSceneName
  },
  methods: {
    setTitle(name) {
      document.title = `${name} - ${window.$globalconfig.PLATFORM_NAME}`
    },
  },
  watch: {
    getCurrentSceneName(name) {
      this.setTitle(name)
    },
  },
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif

  width: 100%
  height: 100%
</style>
